function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m121.61 135 36.695 10 36.695-10 10-22.5-10-22.5-27.135-10-27.135 10c-.061.144-10.678 27.006-19.12 45z",
  fill: "#ffda2d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m268.304 135c-8.232-17.615-18.991-44.898-19.034-45l-27.135-10-27.135 10v45l36.652 10z",
  fill: "#fdb504"
}), /*#__PURE__*/React.createElement("path", {
  d: "m90.25 191-15.227 8.578c-25.826 34.545-60.023 87.476-60.023 130.422 0 99.25 80.745 180 180 180l10-187.5-10-187.5c-19.886 0-61.673 0-73.39 0-5.422 11.56-12.192 21.928-19.839 30.995-1.859 2.204-3.734 4.451-5.621 6.738z",
  fill: "#0a617d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m129.663 221.027c-12.603-10.503-22.519-23.47-29.284-37.914-12.818-27.365-9.966-50.314-10.379-54.94v-8.173c0-16.542 13.461-30 30.006-30h20.724l2.5-15-17.5-15c-.12 0-5.929 0-5.724 0-33.084 0-60.006 26.913-60.006 60v16.345c0 41.74 18.391 81.006 50.458 107.729 19.061 15.884 22.331 43.875 7.443 63.725-3.463 4.617-6.438 8.584-9.901 13.201 8.394 6.295 15.606 11.705 24 18 3.463-4.617 6.439-8.584 9.901-13.201 12.238-16.318 17.013-35.982 14.811-54.831-2.201-18.849-11.38-36.883-27.049-49.941z",
  fill: "#fdb504"
}), /*#__PURE__*/React.createElement("path", {
  d: "m95.729 0c12.196 24.392 37.818 75.636 45 90h54.27l10-45-9.999-45c-6.685 0-92.536 0-99.271 0z",
  fill: "#0a617d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m371.239 299.999c-5.357-21.943-15.985-43.278-28.499-63.003-16.777-26.447-35.966-48.774-54.663-71.01-7.898-9.391-14.548-19.808-19.773-30.986-19.933 0-61.67 0-73.304 0v375c31.547 0 62.661-8.352 90.002-24.118z",
  fill: "#08475e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m294.271 0c-6.685 0-92.537 0-99.271 0v90h54.27c12.196-24.392 37.818-75.636 45.001-90z",
  fill: "#08475e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m303.5 370c-10.217 0-18.5 8.283-18.5 18.5v33c0 10.217 8.283 18.5 18.5 18.5l42.167 10 44.333-10 10-35-10-35-43.25-10z",
  fill: "#fdb504"
}), /*#__PURE__*/React.createElement("path", {
  d: "m476.5 370-40.167-10-46.333 10v70l52.5 10 34-10c10.217 0 18.5-8.283 18.5-18.5 0-11.541 0-21.458 0-33 0-10.217-8.283-18.5-18.5-18.5z",
  fill: "#f77e01"
}), /*#__PURE__*/React.createElement("path", {
  d: "m303.5 300c-10.217 0-18.5 8.283-18.5 18.5v33c0 10.217 8.283 18.5 18.5 18.5h86.5l10-35-10-35c-10.505 0-75.958 0-86.5 0z",
  fill: "#ffda2d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m303.5 440c-10.217 0-18.5 8.283-18.5 18.5v33c0 10.217 8.283 18.5 18.5 18.5h86.5l10-30.5-10-39.5z",
  fill: "#ffda2d"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fdb504"
}, /*#__PURE__*/React.createElement("path", {
  d: "m476.5 300c-10.505 0-75.958 0-86.5 0v70h86.5c10.217 0 18.5-8.283 18.5-18.5 0-11.542 0-21.458 0-33 0-5.108-2.071-9.733-5.418-13.082-3.349-3.347-7.974-5.418-13.082-5.418z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m476.5 440h-86.5v70h86.5c10.217 0 18.5-8.283 18.5-18.5 0-11.541 0-21.458 0-33 0-10.217-8.283-18.5-18.5-18.5z"
})));

const SvgHourglass = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  enableBackground: "new 0 0 510 510",
  height: 25,
  viewBox: "0 0 510 510",
  width: 25,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHourglass, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hourglass.2caf0613.svg";
export { ForwardRef as ReactComponent };